export default {
  geolocation: {
    lat: '44.439663',
    lng: '26.096306',
    label: '010001 Bucharest',
  },
  price_rules: {
    grouping: '.',
    decimal: ',',
  },
}
